import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["modifier"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LeftOutlined, UserOutlined } from '@ant-design/icons';
import { AppContext } from "../DixuApp/DixuApp";
import DixuButton from "../DixuButton/DixuButton";
import DixuForm, { validators } from "../DixuForm/DixuForm";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuInput from "../DixuInput/DixuInput";
import DixuLink from "../DixuLink/DixuLink";
import DixuNotification from "../DixuNotification/DixuNotification";
import DixuSelect from "../DixuSelect/DixuSelect";
import DixuStepFlow from "../DixuStepFlow/DixuStepFlow";
import DixuSwitch from "../DixuSwitch/DixuSwitch";
import DixuText from "../DixuText/DixuText";
import DixuTitle from "../DixuTitle/DixuTitle";
import useAfterInitialRender from "../../hooks/useAfterInitialRender";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import Router, { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { getErrorDescription, post, redirect, registerUser, updateUser } from "../../services/ApiService";
import { decodeReferrerPath, omitReduntantQueryParams, toQueryString } from "../../utils/RouterUtils";
import { CountriesInLinear, LanguageInLinear } from "../../utils/DixuConstants";
const FlowContext = /*#__PURE__*/React.createContext({
  form: undefined,
  flow: undefined,
  stepInfo: undefined,
  isSubmitting: undefined
});
const StepInnerContent = _ref => {
  let {
    size,
    children
  } = _ref;
  const colProps = {
    md: {
      xs: 24,
      xl: 18,
      xxl: 16
    }
  }[size || 'md'];
  return /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, colProps, children));
};
const Step0 = () => {
  const {
    t
  } = useTranslation(['register']);
  const {
    form,
    flow,
    getTitle
  } = useContext(FlowContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "accountType",
    hidden: true
  }, /*#__PURE__*/React.createElement(DixuInput, null)), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 32]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 32]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, getTitle(0, {
    level: '1'
  }), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-6",
    block: true
  }, t('register:AccountType.Description'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    shadow: "1",
    size: "xl",
    justify: "start",
    weight: "bold",
    icon: /*#__PURE__*/React.createElement(UserOutlined, null),
    block: true,
    onClick: () => {
      form.setFieldValue('accountType', 'INDIVIDUAL');
      flow.goToNextStep();
    }
  }, t('register:AccountType.Individual'))))))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-6",
    align: "center",
    block: true
  }, t('register:AccountType.AlreadyHaveAccount'), ' ', /*#__PURE__*/React.createElement(DixuLink, {
    href: "/login",
    weight: "bold",
    noRouterLink: true
  }, t('register:AccountType.LogIn'))))));
};
const Step1 = () => {
  const {
    t
  } = useTranslation(['common', 'register']);
  const {
    form,
    getTitle,
    isSubmitting
  } = useContext(FlowContext);
  return /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    noStyle: true,
    shouldUpdate: "accountType"
  }, () => {
    const {
      accountType
    } = form.getFieldsValue(true);
    return getTitle(1, {
      modifier: accountType
    });
  })), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(StepInnerContent, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "name",
    label: t('common:Name'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, null)), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "email",
    label: t('common:Email'),
    rules: [{
      required: true,
      type: 'email'
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "email"
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "languageInLinear",
    label: t('common:Language'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuSelect, null, Object.values(LanguageInLinear).map(language => /*#__PURE__*/React.createElement(DixuSelect.Option, {
    key: language,
    value: language
  }, t(`register:Languages.${language}`))))), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "country",
    label: t('common:Nationality'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuSelect, null, Object.values(CountriesInLinear).map(country => /*#__PURE__*/React.createElement(DixuSelect.Option, {
    key: country,
    value: country
  }, t(`register:Countries.${country}`))))), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "password",
    label: t('common:Password'),
    rules: [{
      required: true
    }, {
      validator: validators.password({
        invalidCharactersText: t('Salasanassa tulee käyttää vain sallittuja merkkejä'),
        invalidLengthText: t('Salasanan pituus tulee olla vähintään 8 merkkiä'),
        invalidUpperCaseText: t('Salasanassa tulee olla vähintään yksi iso kirjain'),
        invalidLowerCaseText: t('Salasanassa tulee olla vähintään yksi pieni kirjain'),
        invalidDigitText: t('Salasanassa tulee olla vähintään yksi numero')
      })
    }],
    onChange: () => {
      const {
        passwordConfirm
      } = form.getFieldsValue();
      if (passwordConfirm) {
        form.validateFields(['passwordConfirm']);
      }
    }
  }, /*#__PURE__*/React.createElement(DixuInput.Password, {
    type: "password"
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "passwordConfirm",
    label: t('register:BasicInfo.RepeatPassword'),
    rules: [{
      required: true
    }, {
      validator: (rule, value) => {
        const {
          password
        } = form.getFieldsValue();
        if (value !== password) {
          return Promise.reject('Salasanat eivät täsmää');
        }
        return Promise.resolve();
      }
    }]
  }, /*#__PURE__*/React.createElement(DixuInput.Password, {
    type: "password"
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "tos",
    valuePropName: "checked",
    rules: [{
      required: true
    }, {
      validator: validators.boolean({
        invalidText: t('common:Validation.RequiredField')
      })
    }]
  }, /*#__PURE__*/React.createElement(DixuSwitch, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "tos",
    valuePropName: "checked",
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "Hyv\xE4ksyn\xA0", /*#__PURE__*/React.createElement(DixuLink, {
      href: "/pdfs/K\xE4ytt\xF6ehdot.pdf",
      weight: "bold",
      external: true
    }, "k\xE4ytt\xF6ehdot"))
  })))))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    htmlType: "submit",
    size: "lg",
    loading: isSubmitting,
    block: true
  }, t('register:BasicInfo.CreateAccount')))))))));
};
const Step2 = () => {
  const {
    t
  } = useTranslation(['common', 'register']);
  const {
    getTitle,
    isSubmitting
  } = useContext(FlowContext);
  return /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 32]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, getTitle(2), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-6",
    block: true
  }, t('register:ContactInfo.Description'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(StepInnerContent, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 32]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "tel",
    label: t('common:Phone')
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "tel",
    maxLength: 24
  }))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    htmlType: "submit",
    size: "lg",
    loading: isSubmitting,
    block: true
  }, t('register:ContactInfo.Confirm')))))))));
};
const Step3 = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    getTitle
  } = useContext(FlowContext);
  const router = useRouter();
  const {
    query
  } = router || {};
  const {
    referrerPath
  } = query || {};
  const href = decodeReferrerPath(referrerPath) || '/oma-dixu';
  return /*#__PURE__*/React.createElement(StepInnerContent, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 12]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, getTitle(3)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: 'primary',
    size: 'lg',
    block: true,
    href
  }, t('common:Continue')))))));
};
const Header = () => {
  const {
    flow,
    stepInfo
  } = useContext(FlowContext);
  const {
    t
  } = useTranslation(['common']);
  const phaseText = (() => {
    return [flow.currentStep, flow.stepCount - 1].map(e => `0${e}`).join(' / ');
  })();
  const currentStepLabel = stepInfo[flow.currentStep]?.label;
  const showBackButton = (() => {
    return ![0, 2, 3].includes(flow.currentStep);
  })();
  const showPhaseAndTitle = (() => {
    return ![0].includes(flow.currentStep);
  })();
  return /*#__PURE__*/React.createElement("div", {
    className: "p-t-32 p-b-32 p-l-16 p-r-16"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 22,
    xl: 20
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "space-between",
    align: "middle",
    gutter: 32,
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, {
    flex: "0 0 auto"
  }, /*#__PURE__*/React.createElement(DixuStepFlow.Step, {
    active: showBackButton
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "link",
    icon: /*#__PURE__*/React.createElement(LeftOutlined, null),
    weight: "bold",
    size: "lg",
    noPadding: true,
    onClick: () => {
      flow.goToPreviousStep();
    }
  }, t('common:Return')))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuStepFlow.Step, {
    active: showPhaseAndTitle
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-5",
    align: "right"
  }, phaseText)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-6",
    weight: "bold",
    align: "right"
  }, currentStepLabel)))))))));
};
const DixuRegisterFlow = () => {
  const [form] = DixuForm.useForm();
  const [flow] = DixuStepFlow.useFlow();
  const {
    t
  } = useTranslation(['common', 'register']);
  const router = useRouter();
  const {
    query
  } = router || {};
  const {
    user
  } = useContext(AppContext);
  const steps = [/*#__PURE__*/React.createElement(Step0, null), /*#__PURE__*/React.createElement(Step1, null), /*#__PURE__*/React.createElement(Step2, null), /*#__PURE__*/React.createElement(Step3, null)];
  const mappedSteps = steps.map((step, index) => {
    return /*#__PURE__*/React.createElement(DixuStepFlow.Step, {
      key: index.toString(36)
    }, step);
  });
  const stepInfo = {
    0: {
      info: t('register:AccountType.Info'),
      label: '',
      title: t('register:AccountType.Title')
    },
    1: {
      info: t('register:BasicInfo.Info.Individual'),
      label: t('register:BasicInfo.Label'),
      title: {
        INDIVIDUAL: t('register:BasicInfo.Title.Individual'),
        CORPORATE: t('register:BasicInfo.Title.Corporate')
      }
    },
    2: {
      info: t('register:ContactInfo.Info'),
      label: t('register:ContactInfo.Label'),
      title: t('register:ContactInfo.Title')
    },
    3: {
      info: t('register:Completed.Info'),
      label: t('register:Completed.Label'),
      title: t('register:Completed.Title')
    }
  };
  const getTitle = function (step) {
    let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      {
        modifier
      } = _ref2,
      titleProps = _objectWithoutProperties(_ref2, _excluded);
    const title = (() => {
      const value = stepInfo[step]?.title;
      if (modifier) {
        return value[modifier];
      }
      if (typeof value !== 'string') {
        return null;
      }
      return value;
    })();
    return /*#__PURE__*/React.createElement(DixuTitle, _objectSpread({
      level: '2',
      appear: '2',
      weight: 'bold'
    }, titleProps), title);
  };
  const [submit, isSubmitting] = useIsLoading(async values => {
    const {
      currentStep
    } = flow;
    if (currentStep === 1) {
      try {
        const {
          token
        } = await registerUser({
          data: {
            user: values,
            lang: 'fi'
          }
        });
        await post(`/api/autologin`, {
          baseURL: '',
          headers: {
            token
          }
        });
        const newQuery = _objectSpread(_objectSpread({}, omitReduntantQueryParams(Router?.query)), {}, {
          step: '2'
        });
        redirect(`/rekisteroidy${toQueryString(newQuery)}`, {
          hard: true
        });
        await new Promise(() => {});
      } catch (error) {
        DixuNotification.error({
          message: 'Rekisteröityminen epäonnistui',
          description: getErrorDescription(error)
        });
      }
    } else if (currentStep === 2) {
      try {
        await updateUser({
          data: {
            user: JSON.stringify(_objectSpread(_objectSpread({}, values), {}, {
              id: user?.id,
              name: user?.displayName,
              email: user?.emails?.[0]?.value
            }))
          }
        });
        flow.goToNextStep();
      } catch (error) {
        DixuNotification.error({
          message: 'Tietojen päivittäminen epäonnistui',
          description: getErrorDescription(error)
        });
      }
    }
  });
  useAfterInitialRender(() => {
    const {
      step
    } = query || {};
    if (step === '2' && user) {
      flow.goToStep(2);
    }
  }, []);
  const context = {
    form,
    flow,
    stepInfo,
    getTitle,
    isSubmitting
  };
  return /*#__PURE__*/React.createElement(FlowContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(DixuForm, {
    form: form,
    name: "register",
    colorScheme: "reverse",
    onFinish: submit
  }, /*#__PURE__*/React.createElement(DixuStepFlow, {
    flow: flow,
    info: Object.values(stepInfo).map(e => e.info),
    header: /*#__PURE__*/React.createElement(Header, null)
  }, mappedSteps)));
};
DixuRegisterFlow.defaultProps = {};
export default DixuRegisterFlow;